export default __webpack_public_path__ + "static/media/cover1.328a22e5.jpeg";